// Internal actions for the googleTagManager SubDomain
// IMPORTANT: Prefix your string with "GTM" in order to prevent naming collisions with the application constants
export const Actions = Object.freeze({
  APP_STORE_LINK_CLICKED: 'GTM_APP_STORE_LINK_CLICKED',
  SIGN_UP_CLICKED: 'GTM_SIGN_UP_CLICKED',
  UPGRADE_CTA_CLICKED: 'GTM_UPGRADE_CTA_CLICKED',
  UPGRADE_DISCOUNT_PLAN_LINK_CLICKED: 'GTM_UPGRADE_DISCOUNT_PLAN_LINK_CLICKED',
  VIEW_PLANS_CLICKED: 'GTM_VIEW_PLANS_CLICKED',
} as const);

// External events that are sent to Google Tag Manager
export const EventNames = Object.freeze({
  ACQUIRE_OFFER: 'acquireOffer',
  APP_STORE_CTA_CLICK: 'appStoreCtaClick',
  AUTHENTICATION: 'authentication',
  SIGN_UP_CLICK: 'signUpClick',
  UPGRADE_CTA_CLICK: 'upgradeCtaClick',
  UPGRADE_DISCOUNT_PLAN_LINK_CLICKED: 'upgradeDiscountPlanLinkClick',
  VIEW_PLANS_CLICK: 'viewPlansClick',
} as const);

// These variable names match up with the "User Defined" Data Layer props in the GTM admin tool.
// Do not change these without also updating the variable names in the GTM admin tool.
export const Variables = Object.freeze({
  AUTH_TYPE: 'authType',
  CAMPAIGN_ID: 'campaignId',
  DISCOUNT_TYPE: 'discountType',
  DURATION_TIME: 'durationTime',
  DURATION_TYPE: 'durationType',
  EVENT: 'event',
  IS_TRIAL: 'isTrial',
  LID: 'lid',
  OFFER_PRICE: 'offerPrice',
  OS_NAME: 'osName',
  PREVIOUS_DISCOUNT_TYPE: 'previousDiscountType',
  PREVIOUS_TIER: 'previousTier',
  SELECTED_DISCOUNT_TYPE: 'selectedDiscountType',
  SELECTED_IS_TRIAL: 'selectedIsTrial',
  SELECTED_TIER: 'selectedTier',
  SKU: 'sku',
  SPECIAL_OFFER_CODE: 'specialOfferCode',
  TIER: 'tier',
  TIMES_RENEWABLE: 'timesRenewable',
  ZIP_CODE: 'zipCode',
} as const);
